export const BLUEFY = 'Bluefy';
export const CHROME_DESKTOP = 'Chrome desktop';
export const CHROME_MOBILE = 'Chrome mobile';
export const WEB_APP = 'WebApp';
